// Third-party
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import { useTranslation } from 'react-i18next';

// Hooks
import { useTheme } from '@mui/material';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useAppStore';
import { useFilter } from '../../../../hooks/useFilter';
import { useFilterTasklists } from '../hooks';

// Redux-toolkit
import { getSelectedTasklist } from '../../../../store/tasklists/selectors';
import { tasklistsActions } from '../../../../store/tasklists/slice';

// Components
import { TasklistTemplateList } from '../../Shared';
import { BaseFilterMenu } from '../../../../components/base';

// Types
import { TTasklist } from '../../../../types';

const TasklistsNav = () => {
  const { tasklistFilterItems, getTasklistsByFilters } = useFilterTasklists();

  const { t } = useTranslation('tasklists');
  const selectedTasklist = useAppSelector(getSelectedTasklist);
  const dispatch = useAppDispatch();
  const { filterItems } = useFilter(tasklistFilterItems);
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);

  const setSelectedTemplate = (tasklist: TTasklist) => {
    dispatch(tasklistsActions.setSelectedTasklist(tasklist));
    if (isMobile) {
      dispatch(tasklistsActions.setIsOpenAllTasklistsNav(false));
    }
  };

  return (
    <Card
      component={Paper}
      sx={{
        width: '100%',
        bgcolor: 'background.paper',
        height: '78vh',
        overflow: 'auto',
        position: 'relative',
      }}
    >
      <CardHeader
        title={isMobile ? '' : t('allTasklists')}
        titleTypographyProps={{
          variant: 'h5',
        }}
        sx={{
          py: 1,
        }}
        action={(
          <BaseFilterMenu items={filterItems} />
        )}
      />
      <Divider sx={{ mb: 1, borderStyle: 'dashed' }} />
      <TasklistTemplateList
        tasklists={getTasklistsByFilters}
        selectedTasklist={selectedTasklist}
        setSelectedTemplate={setSelectedTemplate}
      />
    </Card>
  );
};

export {
  TasklistsNav,
};
